import axiosInstance from "@/utils/axios";

const ENTITY_LIMIT = 5;

export async function entitiesCreatedByUserV4(userId, pageParam, searchString, type = ""){
    const res = await axiosInstance.get(`/v4/users/entitiesWeb/list/${userId}/${(Number(pageParam)*ENTITY_LIMIT)}/${ENTITY_LIMIT}?searchKey=${searchString}${type ? `&type=${type}` : 'DoMyShoot'}`)
    return res?.data
}

export async function moveUserToAnotherEntity(_id){
    const res = await axiosInstance.post(`/v4/users/move-user-to-newEntity`,{entity_id:_id});
    return res?.data;
}